module.exports = __webpack_public_path__ + "202408221624/img/logo.f4785dd3.svg";